
import enhance from './DinamicCrudCustomPesquisa.enhancer'
import DinamicCrudCustomPesquisa from './DinamicCrudCustomPesquisa';

export default enhance(DinamicCrudCustomPesquisa)



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/components/DinamicCrudCustomPesquisa/index.js